// Packages
import { Fragment, Suspense, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";

// Components
import { Language, languages } from "../Language/Language";

// Pages
import Listing from "../Pages/Listing/Listing";
import NotFound from "../Pages/NotFound/NotFound";
// import Interstitial from "../Pages/Interstitial/Interstitial";

// below is used if a market isn't ready to go live
// import Holding from "../Pages/Holding/Holding";

// Helpers
import { getDefaultLanguage } from "./Router.helpers.js";

function RouteWatcher({ onLocaleChange, handleNotFound, centurion }) {
  const { locale, benefit } = useParams();
  const location = useLocation();

  if(!document.documentElement.getAttribute('lang')){
    document.documentElement.setAttribute('lang', locale);
  }

  useEffect(() => {
    if (window.tuiTrack) {
      window.tuiTrack.trackPage();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!locale) {
      return;
    }
    // Replace en-gb failsafe: check if locale in languages AND country showLandingPage
    if (locale && locale in languages && locale.includes("-")) {
      // TODO: extract countries outside hook so only loaded once...?
      async function fetchMyAPI() {
        let res = await fetch(`${process.env.REACT_APP_API_PATH}/api/countries`);
        return await res.json();
      }
      fetchMyAPI().then((r) => {
        if (r && r.length) {
          let props = null;
          const id = locale.split("-")[1].toUpperCase();
          r.forEach(region => {
            const country = region.countries.find(c => c.key === id);
            if (country && !props) {
              props = country;
            }
          });

          const centurionLocale = `centurion-${locale}`;
          if(centurion && locale !== 'fr-fr') {
            handleNotFound();
          } else if(centurion && props.showLandingPage && Object.keys(languages).includes(centurionLocale)) {
            onLocaleChange({ locale: centurionLocale });
          }
          else if(benefit === 'sbs-diningbenefit' && props.showLandingPage && Object.keys(languages).includes(`sbs-${locale}`)) {
            onLocaleChange({ locale: `sbs-${locale}` });
          }
          else if (props.showLandingPage) {
            onLocaleChange({ locale: locale });
          } else {
            handleNotFound();
          }
        }
      });
    } else {
      handleNotFound();
    }
  }, [locale]);

  return null;
}

// Router
export default function Router() {
  const [lang, setLang] = useState(getDefaultLanguage());
  const [isNotFound, setIsNotFound] = useState(false);

  function onLocaleChange({ locale }) {
    setLang(locale);
  }

  function handleNotFound(){
    setIsNotFound(true);
  }

  function BenefitLanding() {
    return (
        isNotFound
        ? <NotFound />
        : (
          <Suspense fallback={<div></div>}>
            <Fragment>
              <RouteWatcher onLocaleChange={onLocaleChange} handleNotFound={handleNotFound} />
              <Listing />
            </Fragment>
          </Suspense>
        )
    );
  }

  function CenturionLanding() {
    return (
        isNotFound
        ? <NotFound />
        : (
          <Suspense fallback={<div></div>}>
            <Fragment>
              <RouteWatcher onLocaleChange={onLocaleChange} handleNotFound={handleNotFound} centurion={true} />
              <Listing />
            </Fragment>
          </Suspense>
        )
    );
  }

  return (
    <Language.Provider value={languages[lang]}>
      <BrowserRouter>
        <Routes>
          {/* <Route path="/de-de/campaigns/platinum-retail-benefit/" element={<Interstitial onReady={platinumCampaignReady} />} /> */}
          {/* used if a market isn't ready to go live, update locale */}
          {/* <Route path="/en-th/benefits/:benefit/" element={ <Holding /> } />
          <Route path="/th-th/benefits/:benefit/" element={ <Holding /> } /> */}
          {/* end */}
          <Route path="/:locale/benefits/:benefit/centurion/" element={ <CenturionLanding /> } />
          <Route path="/:locale/benefits/:benefit/" element={ <BenefitLanding /> } />
          <Route path="/:locale/avantages/avantagepourrestaurants/" element={ <BenefitLanding /> } />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Language.Provider>
  );
}
